import React, { useCallback, useEffect, useState } from "react";
import CreditDebitPopup from "../popup/credit-debit-popup";
import LedgerPopUp from "../popup/ledger-popup";
import { useParams } from "react-router-dom";
import axiosInstance from "../../../utils/axiosInstance";


const PopUpPage = () => {

    const { type,userId } = useParams(); 
    const [pageLoad, setPageLoad] = useState(false);
    const [userData, setuserData] = useState([]);
    const [displayMode, setDisplayMode] = useState('Cash'); 
    const [creditDebitObj, setCreditDebitObj] = useState({}); 
     

    let CashDepositTxt = "";
    let CashWithTxt = ""; 

    let CreditDepositTxt = "";
    let CreditWithTxt = ""; 
    

    const changeMode = (mode) => { 
        setDisplayMode(mode);
    };

    useEffect(() => { 
        const fetchUserById = async () => {
            if(userId!=="")
            {
                let tt= userId;
                console.log("Fetching user data for ID:", tt);
                const response = await axiosInstance.get("user/"+userId);
                setuserData(response.data); 

                let username = response.data.uname;
                let sponsor = response.data.sponsor;
                let obj = {};

                obj.CashDepositTxt = "Cash payment to "+sponsor +" from "+username;
                obj.CashWithTxt = "Cash payment to "+username +" from "+sponsor;  
                obj.CreditDepositTxt="Credit Issued to "+username;  
                obj.CreditWithTxt = "Credit Withdrawn from "+username;   
                setCreditDebitObj(obj);
                setPageLoad(true);
            }
        };
        fetchUserById();
    }, []);
 
    return (
      <div>
        <div
          style={{
            width: "100%",
            textAlign: "center",
            display: pageLoad ? "none" : "block"
          }}
        >
          <img src="../../../assets/images/loadinggif.gif" alt="Loader" />
        </div>

        <div style={{ display: pageLoad ? "" : "none" }}>
          {type == "cd" ? (
            <CreditDebitPopup
              userData={userData}
              onChangeMode={changeMode}
              displayMode={displayMode}
              creditDebitObj={creditDebitObj}
            ></CreditDebitPopup>
          ) : (
            ""
          )}

          {type == "le" || type == "crle" ? (
            <LedgerPopUp userData={userData}></LedgerPopUp>
          ) : (
            ""
          )}
        </div>
      </div>
    );
}

export default PopUpPage;

